<button class="color-picker__button"
        (click)="toggleMenu()"
        data-e2e="colorPicker-menu"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen"
        aria-controls="color-picker-menu"
        id="color-picker-control-color">
    <span class="color-picker__button-label color-picker__button-label--hidden"
          aria-live="polite"
          aria-atomic="true">
        {{ 'generic.accessibility_selected_color' | translate }} {{ selectedColor }}
    </span>
    <span class="color-picker__button-label">
        {{ 'groups-management.chose_color' | translate }}
    </span>
    <div class="color-picker__button-chip"
         aria-hidden="true"
         [style.background-color]="selectedColor">
    </div>
</button>

@if (menuOpen) {
    <div class="color-picker__menu"
         role="listbox"
         id="color-picker-menu"
         [attr.aria-label]="'generic.accesibility_choose_color' | translate">
        @for (color of colors; track $index; let i = $index) {
            <button class="color-picker__menu-option"
                 role="option"
                 tabindex="0"
                 [attr.data-e2e]="'colorPicker-menu-item-' + i"
                 [class.color-picker__menu-option--selected]="isSelected(color)"
                 [style.background-color]="color"
                 [attr.aria-selected]="isSelected(color)"
                 [attr.aria-label]="color"
                 [title]="isSelected(color) ? ('generic.accessibility_selected_color' + ' ' + color) : color"
                 (click)="selectColor(color)"
                 (keydown)="handleMenuKey($event,i)">
            </button>
        }
    </div>
}